const AVAILABILITY_MANAGEMENT_GA_EVENTS = {
  OFFER_ANOTHER_DATE_MODAL: {
    OPEN: 'avail_offer_date_modal_open',
    CLOSE: 'avail_offer_date_modal_close',
    DECLINE: 'avail_offer_date_modal_decline_click',
    OFFER_DATE: 'avail_offer_date_modal_offer_date_click',
  },
  UPDATE_CALENDAR_PROMPT: {
    OPEN: 'avail_update_calendar_modal_open',
    CLOSE: 'avail_update_calendar_modal_close',
    EDIT: 'avail_update_calendar_modal_edit_click',
    NO: 'avail_update_calendar_modal_no_click',
    YES: 'avail_update_calendar_modal_yes_click',
  },
  UNAVAILABLE_EDITOR_MODAL: {
    OPEN: 'avail_unavailable_editor_modal_open',
    CLOSE: 'avail_unavailable_editor_modal_close',
    SAVE: 'avail_unavailable_editor_modal_save',
  },
  CALENDAR_EVENT_CREATED: 'avail_update_calendar_event_created',
};

export default AVAILABILITY_MANAGEMENT_GA_EVENTS;
